import React, { useEffect, useState } from 'react'
import { Text, View, TextInput, StyleSheet, Alert, Image, StatusBar, ImageSourcePropType, Linking, Modal, Dimensions } from 'react-native'
import Constants from 'expo-constants'
import NetInfo from '@react-native-community/netinfo'
import { AntDesign, Feather } from '@expo/vector-icons'
import { FormContentsModel, ModelAnswerFromProps } from '../models/StoreDetailModel'
import { TouchableOpacity } from 'react-native-gesture-handler'
import * as ImagePicker from 'expo-image-picker'
import { uploadData, getUrl } from 'aws-amplify/storage'
import { getImageStogeUrl, getUrlSave } from '../../imageUploader/ImageStorage'
import theme from '../../../../theme'
import styles from './InputPhotoItemStyles'
import { schedulesServices } from '../../../../database/schedules.database'
import { Loader, LoaderImage } from '../../customUtils/Components/Loader'
import { Ionicons } from '@expo/vector-icons'
import { eventEmitter, get_url_save_photo, validateConnectionNetwork } from '../../../utils/functions.utils'
import { getConection } from '../../appBar/context/HeaderContext'
import { getLanguage } from '../../appBar/context/LocalizationContext'
import { CameraComponent } from '../../customUtils/CameraComponent'
import { useBottomSheet } from '../../customUtils/context/BottomSheetContext'
import { placeholderGeneral } from '../../customUtils/Constants'
import { useStoreStatusStore } from '../../../redux/zustand/storesStatusStore'
import { CampaignStatus } from '../StatusTagsStores'
import { useModerationPeriodStore } from '../../../redux/zustand/modarationPeriodStore'
import { CHECKIN_STATUS, FORM_TYPES } from '../constants/constants.stores'

const width = Dimensions.get('window').width

interface InputPhotoImageItemProps {
    item: FormContentsModel
    hasCamera: boolean
    hasGalery: boolean
    form_id: string
    schedule_id: string
    store_id: string
    checkComplete: (option?: ModelAnswerFromProps) => void
    formType: number
    statusCheckin?: number
    getStatusForm?: () => number | null
}

export const InputPhotoImageItem = React.memo(
    ({
        item,
        hasCamera,
        hasGalery,
        form_id,
        schedule_id,
        store_id,
        checkComplete,
        formType,
        statusCheckin,
        getStatusForm,
    }: InputPhotoImageItemProps) => {
        const { languageFile } = getLanguage()
        const [image, setImage] = useState<ImageSourcePropType | null>(null)
        const { isConnected, hasInternet } = getConection()
        const placeHolder = require('../../../../assets/placeholderImage.png')
        const [showCameraModal, setShowCameraModal] = useState(false)
        const { openBottomSheet } = useBottomSheet()
        const [isCameraVisible, setIsCameraVisible] = useState(false)
        const [comment, setComment] = useState('')
        const storeStatusStore = useStoreStatusStore()
        const moderationPeriodStore = useModerationPeriodStore()
        const isUserBlocked = moderationPeriodStore.isUserBlocked()
        const expoConfig = Constants.expoConfig || { name: '' }

        useEffect(() => {
            //console.log('46 ---- item: ', JSON.stringify(item))

            if (item?.old_response) {
                if (item?.old_response.moderation) {
                    // console.log('53 ---- item.old_response.moderation: ', item.old_response.moderation)
                    setComment(item.old_response.moderation.moderate_comment ?? '')
                }

                if (item?.old_response.media || item?.old_response.questionImage) {
                    if (isConnected && hasInternet) {
                        const media = item?.old_response.media ?? item?.old_response.questionImage
                        const [, newImageUrl] = media.split('public/')
                        getImageStogeUrl(newImageUrl).then((imageUrl) => {
                            setImage({ uri: String(imageUrl) })
                        })
                    } else {
                        setImage(placeHolder)
                    }
                } else {
                    setImage(null)
                }
            }
        }, [item?.old_response])

        const handleImagePickerResult = async (photoUri: string) => {
            try {
                eventEmitter.emit('process_start_image')
                if (photoUri) {
                    let answer: ModelAnswerFromProps = null
                    try {
                        const res_get_url_save_photo = get_url_save_photo('/stores/form')
                        const filename = res_get_url_save_photo
                        let answerScore = '0'
                        if (item.score != null && item.score > 0) answerScore = item.score.toString()
                        answer = {
                            _id: item._id,
                            option_selected_text: [],
                            option_selected_id: [],
                            question_id: item._id,
                            // media: imageUrl,
                            media: '',
                            question_text: item.title,
                            score: answerScore,
                            status: 1,
                            date_finish: new Date().toString(),
                            date_init: new Date().toString(),
                            question_input: '',
                            field_media: '',
                            field_text: '',
                            questionScore: item.questionScore,
                            type: item.input_type.type,
                            ponderar: item.score && item.score > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                            question: item.title,
                            questionOptionSelected: [],
                            questionOptionSelectedText: [],
                            questionType: {
                                title: item.input_type.title,
                                type: item.input_type.type,
                                id: item.input_type._id,
                            },
                            questionPrice: '',
                            description: '',
                            tag: '',
                            questionImage: '',
                            questionInput: '',
                            pickerResult_uri: '', // si se me genera bien la url no hace falta guardar el pick
                        }

                        answer.media = filename
                        answer.questionImage = filename
                        answer.pickerResult_uri = photoUri

                        setImage(placeHolder)
                        // const isConnected = await validateConnectionNetwork()
                        // if (isConnected) {
                        //     const response = await fetch(photoUri)
                        //     if (!response.ok) {
                        //         throw new Error('115 Error al subir la imagen')
                        //     }
                        //     const blob = await response.blob()

                        //     const { imageUrl, imageUrlDB } = await getUrlSave(filename, photoUri)

                        //     answer.media = imageUrlDB ?? res_get_url_save_photo
                        //     answer.questionImage = imageUrlDB ?? res_get_url_save_photo
                        //     answer.pickerResult_uri = imageUrlDB ?? res_get_url_save_photo

                        //     onPicture(imageUrl)

                        // }
                        //
                        setImage({ uri: photoUri })
                    } catch (error) {
                        setShowCameraModal(false)
                        console.error('106 Error al subir la imagen:', error)
                        eventEmitter.emit('process_end_image')
                    } finally {
                        try {
                            schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)
                            await checkComplete(answer)
                        } catch (e) {
                            eventEmitter.emit('process_end_image')
                            Alert.alert('Error', 'No se pudo subir la imagen', e)
                        } finally {
                            setShowCameraModal(false)
                        }

                        // closeBottomSheet(true)
                    }
                }
                eventEmitter.emit('process_end_image')
            } catch (error) {
                console.error('167 --- error - handleImagePickerResult: ', error)
            }
        }

        const onPicture = (image: string) => {
            // closeBottomSheet(true)
        }
        const deleteImage = () => {
            const answer: ModelAnswerFromProps = {
                _id: item._id,
                option_selected_text: [],
                option_selected_id: [],
                question_id: item._id,
                media: null,
                question_text: item.title,
                score: '0',
                status: 1,
                date_finish: new Date().toString(),
                date_init: new Date().toString(),
                question_input: '',
                field_media: '',
                field_text: '',
                questionScore: item.questionScore,
                type: item.input_type.type,
                ponderar: item.questionScore && item.questionScore > 0, //[7, 8, 14, 18].includes(item.input_type.type),

                question: item.title,
                questionOptionSelected: [],
                questionOptionSelectedText: [],
                questionType: {
                    title: item.input_type.title,
                    type: item.input_type.type,
                    id: item.input_type._id,
                },
                questionPrice: '',
                description: '',
                tag: '',
                questionImage: '',
                questionInput: '',
            }

            setImage(null)
            schedulesServices.updateFormAnswerSchedule(answer, schedule_id, form_id, store_id)
            checkComplete(answer)
        }
        const setSheet = async () => {
            try {
                // console.log('213 --- formType: ', formType)
                if (
                    storeStatusStore.getStoreStatus(store_id) === CampaignStatus.STATUS_FORM_PENDING_MODERATION ||
                    statusCheckin == CHECKIN_STATUS.CHECKIN_PENDIENTE
                ) {
                    console.log('216 -- status_store: ', storeStatusStore.getStoreStatus(store_id))
                    console.log('217 -- statusCheckin: ', statusCheckin)
                    return
                }

                if (isUserBlocked && formType === FORM_TYPES.FORM_MODERACION) {
                    console.log('221 -- isUserBlocked: ', isUserBlocked)
                    console.log('222 --- FORM TYPE: ', formType)
                    return
                }

                if (getStatusForm() == CampaignStatus.STATUS_FORM_PENDING_MODERATION) {
                    console.log('229 --- getStatusForm: ', getStatusForm())
                    return
                }

                let cameraPermissionResult = await ImagePicker.requestCameraPermissionsAsync()
                let mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()
                // console.log('cameraPermissionResult', cameraPermissionResult, mediaLibraryPermissionResult)
                if (cameraPermissionResult.granted === false || mediaLibraryPermissionResult.granted === false) {
                    Alert.alert(
                        expoConfig.name + ' quiere acceder a tu camara y galería',
                        expoConfig.name +
                            ' necesita acceso a tu camara y galería para que puedas elegir una foto de perfil o subir imágenes en los relevamientos de las tiendas asignadas.',
                        [
                            {
                                text: 'Cancelar',
                                onPress: async () => {},
                            },
                            {
                                text: 'Configuración',
                                onPress: async () => {
                                    Linking.openSettings()
                                },
                            },
                        ],
                        { cancelable: true },
                    )
                    return
                }
                // Alternar el estado del modal
                setShowCameraModal((prevState) => !prevState)
                // openBottomSheet(<PhotoModal hasCamera={hasCamera} hasGalery={hasGalery} handleImagePickerResult={handleImagePickerResult} />, null, true)
            } catch (error) {
                console.error('227 --- : ', error)
            }
        }

        const handleViewReferece = () => {
            try {
                if (!item.media || item.media === '') {
                    console.log('no hay media..')
                    return
                }
                console.log('224 --- item.media :', item.media)
                console.log('224 --- item.media :', item.media)
                openBottomSheet(
                    <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                        <Text style={[styles.title, { textAlign: 'center' }]}>{item.title ?? ''}</Text>
                        <View style={styles.spacer1}></View>
                        <View>
                            <Image source={{ uri: item.media ? item.media : placeholderGeneral }} style={{ width: width - 24, aspectRatio: 1 }} />
                        </View>
                        <View style={styles.spacer1}></View>
                    </View>,
                )
            } catch (error) {
                console.error('224 --- handleViewReferece :', error)
            }
        }

        /* 
        - toco boton capturar y le pego a setSheet() que me levanta el modal de camara o galeria
        - el boton de referencia lo voy a conectar a una fn handleViewReferece() que levanta la key media del form
    */

        const renderCommentRefused = () => {
            const RenderText = storeStatusStore.getStoreStatus(store_id) === CampaignStatus.STATUS_FORM_REFUSED ? 'Rechazado' : ''
            if (comment !== '' && RenderText !== '') {
                return (
                    <View>
                        <View style={[styles.containerRow, styles.alignCenter, styles.marginHorizontal]}>
                            <Text
                                style={[
                                    styles.status,
                                    { color: CampaignStatus.STATUS_FORM_REFUSED ? theme.colors.error : theme.colors.textSecondary },
                                ]}
                            >
                                {RenderText}
                            </Text>
                            <Feather
                                style={{ paddingLeft: 4 }}
                                name='x'
                                size={20}
                                color={CampaignStatus.STATUS_FORM_REFUSED ? theme.colors.error : theme.colors.textSecondary}
                            />
                        </View>
                        <View style={styles.spacer}></View>
                        <View style={styles.spacer}></View>
                        <Text style={[styles.statusDescriptionText, styles.marginHorizontal]}>{comment}</Text>
                        <View style={styles.spacer1}></View>
                        <View style={styles.spacer1}></View>
                    </View>
                )
            }
        }

        const verifyIsEditable = () => {
            let isEditable = true

            if (isUserBlocked) {
                return (isEditable = false)
            }

            if (statusCheckin == CHECKIN_STATUS.CHECKIN_PENDIENTE) {
                return (isEditable = false)
            }

            if (storeStatusStore.getStoreStatus(store_id) === CampaignStatus.STATUS_FORM_PENDING_MODERATION) {
                return (isEditable = false)
            }

            if (
                storeStatusStore.getStoreStatus(store_id) === CampaignStatus.STATUS_FORM_REFUSED &&
                statusCheckin == CHECKIN_STATUS.CHECKIN_PENDIENTE
            ) {
                return (isEditable = false)
            }

            if (getStatusForm() != null && getStatusForm() == CampaignStatus.STATUS_FORM_PENDING_MODERATION) {
                return (isEditable = false)
            }

            return isEditable
        }

        const isEditable = verifyIsEditable()

        return (
            <View>
                {/*<Text>Media: {JSON.stringify(item.media ?? 'sin media')}</Text>
            <Text>item.input_type: {JSON.stringify(item.input_type)}</Text>*/}
                <Text style={[styles.title, { textAlign: 'center' }]}>{item.title}</Text>
                <View style={styles.spacer1}></View>
                {/* <Text>getStatusForm: {JSON.stringify(getStatusForm())}</Text> */}
                {image ? (
                    <View style={{ flex: 1 }}>
                        <TouchableOpacity onPress={() => setSheet()} style={styles.containerTakePhoto}>
                            {isEditable && (
                                <View style={styles.containerEditPhoto}>
                                    <Feather name='edit-3' size={24} color={'white'} style={{ alignSelf: 'center' }} />
                                </View>
                            )}
                            <View style={styles.takePhoto}>
                                <Image style={styles.previewPhoto} source={image} />
                            </View>
                        </TouchableOpacity>
                    </View>
                ) : (
                    <View style={{ flex: 1 }}>
                        <TouchableOpacity onPress={() => setSheet()} style={styles.containerTakePhoto}>
                            <View style={styles.takePhoto}>
                                <Feather name='camera' size={70} style={[styles.takePhotoAsset, { alignSelf: 'center' }]} color={'white'} />
                                <View style={styles.spacer1}></View>
                                <Text style={[styles.takePhotoText, { color: 'white' }]}>SUBIR IMAGEN</Text>
                            </View>
                        </TouchableOpacity>
                    </View>

                    /*<TouchableOpacity onPress={() => setSheet()}>
                    <View style={styles.floatingButton}>
                        <Text style={styles.floatingButtonText}>AGREGAR FOTO</Text>
                        <Feather name='plus-square' size={16} color={theme.colors.colorPrimary} />
                    </View>
            </TouchableOpacity>*/
                )}
                {showCameraModal && <PhotoModal hasCamera={hasCamera} hasGalery={hasGalery} handleImagePickerResult={handleImagePickerResult} />}
                <View style={styles.spacer1}></View>
                <View style={styles.dividerHorizontalLine}></View>
                <View style={styles.spacer1}></View>

                {renderCommentRefused()}

                <TouchableOpacity onPress={() => handleViewReferece()} style={styles.takePhotoButton}>
                    <Text style={styles.seeReferenceText}>Ver referencia</Text>
                </TouchableOpacity>
                <View style={styles.spacer1}></View>
                {/*<View style={{ flexDirection: 'row', alignContent: 'center', alignSelf: 'center' }}>
                <Text style={[styles.status, { color: theme.colors.textSecondary }]}>Pendiente de aprobación</Text>
                <Feather style={{ paddingLeft: 4 }} name='clock' size={20} color={theme.colors.textSecondary} />
            </View>
            <View style={{ flexDirection: 'row', alignContent: 'center', alignSelf: 'center' }}>
                <Text style={[styles.status, { color: theme.colors.colorApproved }]}>Aprobado</Text>
                <Feather style={{ paddingLeft: 4 }} name='check' size={20} color={theme.colors.colorApproved} />
            </View>
            <View style={{ flexDirection: 'row', alignContent: 'center', alignSelf: 'center' }}>
                <Text style={[styles.status, { color: theme.colors.error }]}>Rechazado</Text>
                <Feather style={{ paddingLeft: 4 }} name='x' size={20} color={theme.colors.error} />
        </View>*/}
            </View>
        )
    },
)

export const PhotoModal = ({
    hasCamera,
    hasGalery,
    handleImagePickerResult,
}: {
    hasCamera: boolean
    hasGalery: boolean
    handleImagePickerResult: (uri: string) => Promise<void>
}) => {
    const { languageFile } = getLanguage() || {}
    const [loading, setLoading] = useState(false)
    const [isCameraVisible, setIsCameraVisible] = useState(false)

    useEffect(() => {
        const onStart = () => setLoading(true)
        const onEnd = () => setLoading(false)

        eventEmitter.on('process_start_image', onStart)
        eventEmitter.on('process_end_image', onEnd)

        return () => {
            eventEmitter.removeListener('process_start_image', onStart)
            eventEmitter.removeListener('process_end_image', onEnd)
        }
    }, [])

    const options: ImagePicker.ImagePickerOptions = {
        allowsEditing: false,
        cameraType: ImagePicker.CameraType.back,
        quality: 0.3, //1, // la calidad 1 es la mas alta disponible, si  se quiere una calidad baja se puede poner un numero entre 0 y 1, ej, 0.5 y reduce la calidad a la mitad
    }

    const closeCamera = () => {
        setIsCameraVisible(false)
    }

    const openCamera = async () => {
        console.log('estoy en la funcion que abre la camara')

        try {
            setIsCameraVisible(true)
        } catch (error) {
            //setLoading(false)
            eventEmitter.emit('process_end_image')
            console.log('🚀 ~ openCamera ~ error:', error)
        }
    }

    const openGalery = async () => {
        try {
            const mediaLibraryPermissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync()
            if (mediaLibraryPermissionResult.granted === false) {
                return
            }
            const pickerResult = await ImagePicker.launchImageLibraryAsync(options)
            if (!pickerResult.canceled) {
                //setLoading(true)
                handleImagePickerResult(pickerResult.assets[0].uri)
            }
        } catch (error) {
            //setLoading(false)
            eventEmitter.emit('process_end_image')
            console.log('🚀 ~ openGalery ~ error:', error)
        }
        // setLoading(false)
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : isCameraVisible ? (
                <View>
                    <Modal visible={true} animationType='slide'>
                        <CameraComponent closeCamera={closeCamera} handleImagePickerResult={handleImagePickerResult} />
                    </Modal>
                </View>
            ) : (
                <View>
                    {/* <StatusBar backgroundColor={'rgba(0, 0, 0, 0.7)'} barStyle='dark-content' /> */}
                    <View style={styles.spacer1}></View>
                    <Text style={[styles.title, { textAlign: 'center' }]}>{languageFile.where_do_you_want}</Text>
                    <View style={styles.iconButtonContainer}>
                        {hasCamera && (
                            <View>
                                <TouchableOpacity style={styles.iconButton} onPress={() => openCamera()}>
                                    <Feather name='camera' size={24} color={theme.colors.colorPrimary} />
                                    <Text style={styles.iconButtonText}>{languageFile.camera.toUpperCase()}</Text>
                                </TouchableOpacity>
                            </View>
                        )}

                        {hasCamera && hasGalery && <View style={styles.dividerVerticalLine}></View>}

                        {hasGalery && (
                            <View>
                                <TouchableOpacity style={styles.iconButton} onPress={() => openGalery()}>
                                    <Feather name='image' size={24} color={theme.colors.colorPrimary} />
                                    <Text style={styles.iconButtonText}>{languageFile.gallery.toUpperCase()}</Text>
                                </TouchableOpacity>
                            </View>
                        )}
                    </View>
                </View>
            )}
        </>
    )
}
